import { fetch } from '@maxtropy/components';

export const queryRequestLimit = () => fetch<{ second: string; minute: string }>(`/api/limit`);
